import React, { useState, useEffect, useRef } from "react";
import { useCookies } from "react-cookie"; // Step 1: Import useCookies
import Header from "./header";
import Footer from "./footer";
import PatientIsi from "./isi/index";
import PropTypes from "prop-types";
import PatientHero from "../patient/hero";
import "../../sass/styles.scss";
import CookieBanner from "../../components/cookie-banner"; 
export default function Layout({
  noShowStickyIsi,
  isPatientHero,
  pageClass,
  children,
  ...props }) {
  
  const [cookies, setCookie] = useCookies(["cookie-disclaimer"]);
  
  const [elmRef, setElmRef] = useState(null);
  const footerRef = useRef(null);

  useEffect(() => {
    setElmRef(footerRef.current);
  }, []);

  const shouldShowCookieBanner = !cookies["cookie-disclaimer"]; 
  
  return (
    <div {...props}>
      <div className={`patient-layout ${pageClass || ""}`}>
        <Header />
        {isPatientHero && <PatientHero />}
        <div className="content-container body-content-container">
          <main className="centered-content">{children}</main>
        </div>

        {elmRef && !noShowStickyIsi && (
          <PatientIsi footerRef={elmRef} />
        )}
        <div ref={footerRef}>
          <Footer />
        </div>
      </div>
      {shouldShowCookieBanner && <CookieBanner />} 
    </div>
  );
}

Layout.propTypes = {
  noShowStickyIsi: PropTypes.bool,
  isPatientHero: PropTypes.bool,
};
